import Util from '@engine/features/dashboard/chart/dashboard_chart_utility';

function updateRangeUI(dataset) {
  var from = dataset[0].x;
  var to = dataset[dataset.length - 1].x;
  $('#date-range').html(from + ' - ' + to);
}

function updateRangeTotalUI(dataset) {
  var sum = 0;

  if (dataset.length) {
    sum = dataset.map(function (object) {
      return object.y;
    }).reduce(function (accumulator, currentValue) {
      return accumulator + currentValue;
    });
  }

  $('#date-range-total').html(Util.formatVolume(sum));
}

function forceUpdate(dataset) {
  updateRangeUI(dataset);
  updateRangeTotalUI(dataset);
}

var Details = {
  forceUpdate: forceUpdate
};
export default Details;